import React, { useEffect, useRef, useState } from "react";

import { _common } from "../common";
import { ServerInterface } from "../ServerInterface";
const common = _common;

export default function DeineNaechsteBuchung(props: { onReDraw: () => void; redraw: number }) {
  const { onReDraw, redraw } = props;
  const lastRedraw = useRef<number>(-1);

  const [myNextBooking, setMyNextBooking] = useState<any | undefined>();
  const [currentBookingIsMoving, setCurrentBookingIsMoving] = useState(false);

  function moveCurrentBooking() {
    common.currentBookingIsMoving = true;
    common.myNextBookingInfo = myNextBooking;
    setCurrentBookingIsMoving(true);
    onReDraw();
  }

  function abortMoveCurrentBooking() {
    common.currentBookingIsMoving = false;
    setCurrentBookingIsMoving(false);
    onReDraw();
  }

  function deleteCurrentBooking() {
    common.myConfirm("Willst Du die Buchung wirklich löschen", function () {
      ServerInterface.deleteBooking(myNextBooking).then(() => {
        setMyNextBooking(undefined);
        onReDraw();
      });
    });
  }
  function deleteCurrentBookingSerie() {
    throw new Error("Function not implemented.");
  }

  useEffect(() => {
    if (lastRedraw.current != redraw) {
      if (common.user) {
        setCurrentBookingIsMoving(common.currentBookingIsMoving);

        ServerInterface.getMyNextBooking(common.user.memberId).then((booking) => {
          setMyNextBooking(booking);
          common.myNextBookingInfo = booking;
          lastRedraw.current = redraw;
        });
      }
    }
  });

  if (myNextBooking == undefined) {
    return null;
  }

  const date = new Date(myNextBooking.date);

  return (
    <div>
      {myNextBooking && (
        <div style={{ overflow: "hidden", width: "100%", marginBottom: "20px" }}>
          <div
            style={{
              // width: "calc(100% - 10px)",
              // margin: 5,
              backgroundColor: "#efef90",

              position: "relative",
              width: "100%",
              boxShadow: "var(--stdShadow)",
              height: "max-content",
              borderRadius: "10px",
              overflow: "hidden",
              border: "1px solid grey",
              padding: "20px",
              textAlign: "left",
            }}
          >
            {currentBookingIsMoving && (
              <div>
                <div id="moveCurrentBooking">Zum Verschieben der Buchung tippe auf eine anderen freien Platz/Uhrzeit</div>
                <div
                  style={{
                    paddingRight: 0,
                    paddingLeft: 0,
                    flexWrap: "nowrap",
                    justifyContent: "center",
                  }}
                  className="modal-footer"
                >
                  <button
                    id="move"
                    type="button"
                    onClick={() => {
                      abortMoveCurrentBooking();
                    }}
                    data-dismiss="modal"
                    style={{ fontSize: "1m", backgroundColor: "indianred" }}
                    className="btn btn-default"
                  >
                    Verschieben Abbrechen
                  </button>
                </div>
              </div>
            )}

            {!currentBookingIsMoving && (
              <div id="deineBuchung" className="deineBuchungTop">
                <div className="container">
                  <div className="row">
                    <h1
                      style={{
                        margin: 0,
                        textAlign: "center",
                        fontSize: "1.5em",
                        marginBottom: "1em",
                      }}
                    >
                      Dein nächstes Match
                    </h1>
                  </div>

                  <table>
                    <tbody>
                      <tr>
                        <td>Datum:</td>
                        <td>
                          <b>
                            &nbsp; &nbsp;
                            {date.toLocaleDateString(window.navigator.language, { weekday: "long" })} {date.toLocaleDateString()}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td>Zeit:</td>
                        <td>
                          <b>
                            &nbsp; &nbsp;
                            {date.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td>Platz:</td>
                        <td>
                          <b>
                            &nbsp; &nbsp;
                            {myNextBooking.court}
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div style={{ marginTop: "1em" }} className="deinePartner">
                    Dein(e) Partner(innen)
                  </div>

                  <div>
                    <ul className="partners">
                      {myNextBooking.partners.map((partner: string) => (
                        <li key={partner.split(";")[0]}>{partner.split(";")[1]}</li>
                      ))}
                    </ul>
                  </div>

                  <div
                    style={{
                      paddingRight: 0,
                      paddingLeft: 0,
                      flexWrap: "nowrap",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "end",
                      gap: "20px",
                    }}
                    className="modal-footer"
                  >
                    <button
                      id="move"
                      type="button"
                      onClick={() => {
                        moveCurrentBooking();
                      }}
                      style={{ fontSize: "1m", backgroundColor: "yellowgreen" }}
                      className="btn"
                    >
                      Verschieben
                    </button>
                    <button
                      id="delete"
                      type="button"
                      onClick={() => {
                        deleteCurrentBooking();
                      }}
                      style={{ fontSize: "1m", backgroundColor: "indianred" }}
                      className="btn"
                    >
                      Löschen
                    </button>
                    <button
                      id="deleteSerie"
                      type="button"
                      onClick={() => {
                        deleteCurrentBookingSerie();
                      }}
                      style={{
                        fontSize: "1m",
                        display: "none",
                        backgroundColor: "red",
                      }}
                      className="btn"
                    >
                      Serie Löschen
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
